import { useAuthStatus } from "@/hooks/use-auth-status";
import { Zap } from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import { CDN_URL } from "@/consts";
import { track } from "@/lib/analytics";
import { useStrings } from "@/lib/i18n/context";

export const HeroButton = () => {
  const { isAuthenticated, isLoading } = useAuthStatus();
  const s = useStrings();

  const href =
    isLoading || !isAuthenticated ? "https://crayo.ai/signup" : "https://crayo.ai/dashboard";

  return (
    <div className="flex items-center justify-center gap-x-6">
      <Link
        href={href}
        onClick={() => track("cta_clicked", { cta: "hero", href })}
        className="relative rounded-full bg-[#335CFF] px-8 py-5 duration-200 ease-in-out hover:scale-[1.01]"
      >
        <span className="relative z-10 flex flex-row items-center gap-4 text-lg font-medium tracking-wide text-white md:text-[26px]">
          <Zap className="h-[1em] w-auto fill-white text-white" />
          {s.cta.tryCrayo}
        </span>
        <Image
          src={`${CDN_URL}/landing/trusted-by-desktop.png`}
          alt="Crayo Logo"
          width={321}
          height={237}
          className="absolute right-0 top-0 max-h-[70px] w-auto translate-x-full max-sm:hidden xl:hidden"
        />
      </Link>
    </div>
  );
};
